function isPassportIssueDateValid(issueDate: Date | null | undefined): boolean {
  if (issueDate == null) {
    return false;
  }

  const nowDate = new Date(Date.now());
  const minDate = new Date(nowDate.setUTCFullYear(nowDate.getFullYear() - 20));
  const dateDifferenceSeconds = Math.floor((Date.now() - issueDate.getTime()) / 1000);

  if (dateDifferenceSeconds < 0 || issueDate.getTime() < minDate.getTime()) {
    return false;
  }

  return true;
}

export default isPassportIssueDateValid;
